import _ from 'lodash';
import $ from 'jquery';
import { observable, action, computed, reaction } from 'mobx';
import axios, { CancelToken } from 'axios';
import ProviderLabelData from './ProviderLabelStore';
import getYearOptions from '../helpers/helpers';

const mobx = require('mobx');


const loanpartDurationLabels = getYearOptions();

const mortgageTypes = [
  { id: 1, name: 'Annuitair', value: 6 },
  { id: 2, name: 'Lineair', value: 7 },
  { id: 3, name: 'Aflosvrij', value: 1 },
];

const initialMortgageForm = {
  providers: [],
  labels: [],
  filteredLabels: [],

  /* Default selected providerId */
  providerId: 41,

  /* SelectedLabel defines what label image and interest rates will be selected */
  labelId: 291,
  houseValue: 330000,
  mortgage: 330000,
  nhg: false,
  forceAutoRiskClassReduction: false,

  /* Default fixedRateTerm for getFixedRateTermsForLabel and getLabelInterest */
  fixedRateTerm: 0,

  fixedRateTerms: [[]],
  labelsInterests: [{
    initialInterest: '-',
  }],

  loanparts: [],

  /* Json array used to calculate loanparts. Uses endpoint /calculate/loanparts  */
  loanpartsPostData: [],
  defaultInterest: 0,
};

const advisorIdAndEndpoints = {
  291: 'https://www.asr.nl/adviseurs/zoeken',
  433: 'https://www.centraalbeheer.nl/hypotheek/afsluiten/Paginas/hypotheekadviseur.aspx',
  24: 'https://www.hypotrust.nl/advies/zoek-uw-adviseur/',
  88: 'https://www.hypotrust.nl/advies/zoek-uw-adviseur/',
  451: 'https://www.hypotrust.nl/advies/zoek-uw-adviseur/',
  398: 'https://www.hypotrust.nl/advies/zoek-uw-adviseur/',
  329: 'https://www.hypotrust.nl/advies/zoek-uw-adviseur/',
  366: 'https://www.hypotrust.nl/advies/zoek-uw-adviseur/',
  408: 'https://www.hypotrust.nl/advies/zoek-uw-adviseur/',
  401: 'https://www.hypotrust.nl/advies/zoek-uw-adviseur/',
};

class CalculationFormStore {
  defaultSelectText = 'Maak aub een keuze';

  @observable accessor mortgageForm = {};
  @observable accessor errorMessage;
  @observable accessor responseError;
  @observable accessor responseErrorFields;
  @observable accessor errorFields = [];
  @observable accessor errorFieldKeys = [];
  @observable accessor loanpartError;
  @observable accessor responseNhgInfo;
  @observable accessor labelIdFromUrl = {
    active: true,
    labelId: '',
  };

  @observable accessor mortgageTypeFromOverview;

  constructor(mortgageForm) {
    this.mortgageForm = mortgageForm;

    this.setDesiredMortgage = this.setDesiredMortgage.bind(this);
    this.setHouseValue = this.setHouseValue.bind(this);
    this.toggleNHG = this.toggleNHG.bind(this);
    this.toggleForceAutoRiskClassReduction = this.toggleForceAutoRiskClassReduction.bind(this);
    this.setProvider = this.setProvider.bind(this);
    this.setLabel = this.setLabel.bind(this);
    this.getFixedRateTermsForLabel = this.getFixedRateTermsForLabel.bind(this);
    this.getLabelInterest = this.getLabelInterest.bind(this);
    this.resetLoanpartsPostData = this.resetLoanpartsPostData.bind(this);
    this.resetSelectedLabelId = this.resetSelectedLabelId.bind(this);
    this.setLabelIdFromUrl = this.setLabelIdFromUrl.bind(this);
    this.setFormFieldsFromOverview = this.setFormFieldsFromOverview.bind(this);
    this.setSelectText = this.setSelectText.bind(this);
    this.setAvailableFixedRateTerms = this.setAvailableFixedRateTerms.bind(this);
    this.setInitialLoanpart = this.setInitialLoanpart.bind(this);
    this.addLoanpart = this.addLoanpart.bind(this);
    this.removeLoanpart = this.removeLoanpart.bind(this);
    this.selectedLabelHasAutoRiskClassReduction = this.selectedLabelHasAutoRiskClassReduction.bind(this);

    reaction(
      () => [ProviderLabelData.allProviders, ProviderLabelData.allLabels],
      (providersAndLabels) => {
        if (providersAndLabels[0].length > 0 && providersAndLabels[1].length > 0) {
          this.mortgageForm.providers = providersAndLabels[0];
          this.mortgageForm.labels = providersAndLabels[1];
        }
      },
    );
  }

  @computed get allProviders() {
    return ProviderLabelData.providers;
  }

  /**
   *
   * @param index
   * @param cb, optionally return callback
   * @returns {Promise.<void>}
   *
   */
  @action
  // eslint-disable-next-line consistent-return
  async getLabelInterest(index, cb) {
    const { loanpartsPostData } = this.mortgageForm;
    let res;
    const self = this;

    if (loanpartsPostData.length >= index + 1) {
      const basePostData = this.setBasePostData(index);
      let postData = {};
      const fixedRateTerm = loanpartsPostData[index].frt ? loanpartsPostData[index].frt : '';

      if (fixedRateTerm) {
        postData = {
          ...basePostData,
          fixedRateTerm,
        };
      }

      loanpartsPostData[index].interest = '-';
      if (_.keys(postData).length > 0) {
        res = await axios.post('/label/interest', postData)
          .then((response) => {
            if (loanpartsPostData.length >= index) {
              loanpartsPostData[index].interest = response.data.initialInterest;

              if (typeof cb === 'function') {
                cb(response.data.initialInterest);
              }
            }

            return response.data;
          })
          .catch((err) => {
            if (err.response.status === 404) {
              self.responseError = 'Er kon geen rente worden gevonden';
            } else {
              this.errorMessage = err;
            }
          });

        return res;
      }
    }
  }

  @action
  // eslint-disable-next-line consistent-return
  async getFixedRateTermsForLabel(index) {
    const { loanpartsPostData } = this.mortgageForm;
    const basePostData = this.setBasePostData(index);
    let responseObject;
    const self = this;

    if (loanpartsPostData.length >= index + 1) {
      const postData = {
        ...basePostData,
      };

      /* Set cancelToken and cancel current request. */
      this.cancelRequest();
      if (_.keys(basePostData).length > 0) {
        responseObject = await axios.post('/label/fixed-rate-term', postData, {
          cancelToken: CancelToken.source().token,
        })
        .then((response) => {
          if (response.data.length > 0) {
            /* Filter dups if endpoint delivers duplicates */
            self.mortgageForm.fixedRateTerms[index] = _.uniqBy(response.data);

            if (index === 0) {
              this.responseError = '';
            }

            return response.data;
          } else if (response.data.length === 0) {
            self.mortgageForm.fixedRateTerms[index] = _.uniqBy(response.data);
            self.mortgageForm.loanpartsPostData[index].frt = 0;
            this.responseError = 'Er zijn geen rentes gevonden.';
            return response.data;
          }

          return response.data;
        })
        .catch(err => this.errorMessage = err);

        return _.uniqBy(responseObject);
      }
    }
  }

  /* If fixedRateTerms and 20 is not available, pick a higher fixed rate term */
  @action setAvailableFixedRateTerms(index, frt) {
    if (this.mortgageForm.fixedRateTerms.length > index) {
      if (!_.isEmpty(this.mortgageForm.fixedRateTerms[index]) && frt === 20 &&
        _.indexOf(this.mortgageForm.fixedRateTerms[index], frt) === -1) {
        const fixedRateTerms = this.mortgageForm.fixedRateTerms[index];
        const frtLabel = _.last(fixedRateTerms);

        this.mortgageForm.loanpartsPostData[index].frt = frtLabel;
        this.setSelectText('frt', `${frtLabel} Jaar`, `frt-${index}`);
      } else if (!_.isEmpty(this.mortgageForm.fixedRateTerms[index])) {
        this.mortgageForm.loanpartsPostData[index].frt = frt;
        this.setSelectText('frt', `${frt} Jaar`, `frt-${index}`);
      }
    }
  }

  @action cancelRequest() {
    if (_.has(this.abortController, 'abort')) {
      /* Always clear pending request. */
      this.abortController.abort();
    }

    this.abortController = new AbortController();
  }

  @action setBasePostData(index) {
    const { loanpartsPostData } = this.mortgageForm;
    let postData = {};
    let mortgageType = 6;

    if (loanpartsPostData.length > index) {
      mortgageType = _.has(loanpartsPostData[index], 'mortgageType') && loanpartsPostData[index].mortgageType;
    }

    const {
      labelId,
      houseValue,
      mortgage,
      nhg,
      forceAutoRiskClassReduction,
    } = this.mortgageForm;

    if (labelId && houseValue && mortgage > 4999 && nhg !== undefined && mortgageType) {
      postData = {
        labelId,
        houseValue,
        mortgage,
        nhg,
        mortgageType,
        forceAutoRiskClassReduction,
      };
    }

    if (mortgage < 5000) {
      this.responseError = 'Gewenste hypotheek bedrag mag niet lager zijn dan €5.000,-';
    }

    return postData;
  }

  @action setFormFieldsFromOverview(mortgageType, mortgage, houseValue, nhg) {
    if (mortgage > 0 || houseValue > 0) {
      this.mortgageTypeFromOverview = mortgageType;
      this.mortgageForm.houseValue = houseValue;
      this.mortgageForm.mortgage = mortgage;

      /* Temporary fix for nhg fix in overview */
      if (nhg === 0) {
        this.mortgageForm.nhg = false;
      } else if (nhg === 1) {
        this.mortgageForm.nhg = true;
      } else {
        this.mortgageForm.nhg = nhg;
      }
    }
  }

  @computed get selectedLabelName() {
    let selectedLabelName = this.mortgageForm.labels.find(label => label.id === this.mortgageForm.labelId);
    if (selectedLabelName) {
      selectedLabelName = selectedLabelName.name;
    }

    return selectedLabelName;
  }

  @computed get mortgageTypes() {
    return mortgageTypes;
  }

  @computed get loanpartDurationLabels() {
    return loanpartDurationLabels;
  }

  @computed get advisorEndpointsById() {
    if (typeof advisorIdAndEndpoints[this.mortgageForm.labelId] === 'undefined') {
      return 'https://www.hypotheekadviseurzoeker.nl/';
    }

    return advisorIdAndEndpoints[this.mortgageForm.labelId];
  }

  @computed get calculationData() {
    const loanParts = this.mortgageForm.loanparts;

    const loanpartsPostData = this.mortgageForm.loanpartsPostData.map((loanpart, index) => ({
      ...loanpart,
      gross: loanParts.length - 1 >= index ? loanParts[index] : 0,
    }));

    return {
      labelId: this.mortgageForm.labelId,
      houseValue: this.mortgageForm.houseValue,
      mortgage: this.mortgageForm.mortgage,
      nhg: this.mortgageForm.nhg,
      forceAutoRiskClassReduction: this.mortgageForm.forceAutoRiskClassReduction,
      loanparts: loanpartsPostData,
    };
  }

  selectedLabelHasAutoRiskClassReduction() {
    const selectedLabel = this.mortgageForm.labels.find(label => label.id === this.mortgageForm.labelId);
    return _.has(selectedLabel, 'hasAutoRiskClassReduction') && selectedLabel.hasAutoRiskClassReduction;
  }

  @action setLabelIdFromUrl() {
    /* Temporary fix for getting current LabelId from url. Should use react router for obtaining params. */
    const pathName = window.location.pathname;
    const labelIdFromUrl = pathName.substring('/bereken/'.length, pathName.length);

    if (labelIdFromUrl) {
      this.labelIdFromUrl.active = true;
      this.labelIdFromUrl.labelId = Number(labelIdFromUrl);
    } else {
      this.labelIdFromUrl.active = false;
    }
  }

  @action setProvider(value, labels) {
    const providerId = Number(value);

    this.mortgageForm.providerId = providerId;

    this.mortgageForm.filteredLabels = labels.filter(label => label.providerId === providerId);

    /* Reset loanpartsPostData */
    this.resetLoanpartsPostData();
  }

  @action setLabel(value) {
    this.mortgageForm.labelId = Number(value);

    /* Reset loanpartsPostData */
    this.resetLoanpartsPostData();

    this.getFixedRateTermsForLabel(0)
      .then(() => this.getFixedRateTermsForLabel(1))
      .then(() => this.getFixedRateTermsForLabel(2))
      .then(() => {
        this.setAvailableFixedRateTerms(0, 20);
        this.setAvailableFixedRateTerms(1, 20);
        this.setAvailableFixedRateTerms(2, 20);
        return this.getLabelInterest(0);
      })
      .then(() => this.getLabelInterest(1))
      .then(() => this.getLabelInterest(2));
  }

  @action resetSelectedLabelId() {
    /* Reset label id */
    this.mortgageForm.labelId = '';
    $('select[name=selected-label]').siblings('.text')
      .text(this.defaultSelectText);
  }

  @action resetLoanpartsPostData() {
    /* Replace text */
    this.setSelectText('frt', this.defaultSelectText, '');

    const loanpartsPostData = mobx.toJS(this.mortgageForm.loanpartsPostData);
    this.mortgageForm.loanpartsPostData = loanpartsPostData.map((postItem) => {
      const newPostItem = { ...postItem };
      newPostItem.frt = 20;
      newPostItem.gross = '';
      newPostItem.interest = '-';

      return newPostItem;
    });
  }

  @action setSelectText(name, text, className) {
    $(`${className} select[name=${name}]`).siblings('.text')
      .text(text);
  }

  @action toggleNHG() {
    this.mortgageForm.nhg = !this.mortgageForm.nhg;
  }

  @action toggleForceAutoRiskClassReduction() {
    this.mortgageForm.forceAutoRiskClassReduction = !this.mortgageForm.forceAutoRiskClassReduction;
  }

  @action setDesiredMortgage(value) {
    this.mortgageForm.mortgage = value;
  }

  @action setHouseValue(value) {
    this.mortgageForm.houseValue = value;
  }

  /*
  *  Set and calculate loanparts
  * */

  /**
   * @param value
   * @param index
   */
  @action setLoanpart(value, index) {
    const loanparts = this.mortgageForm.loanparts;
    loanparts[index] = Number(value);
  }

  @action setInitialLoanpart() {
    const mortgage = this.mortgageForm.mortgage;
    const loanparts = this.mortgageForm.loanparts;

      /* If loanparts are empty set initial loanpart equal to mortgage */
    if (loanparts.length <= 1) {
      loanparts[0] = Number(mortgage);
    }
  }

  @action addLoanpart() {
    if (this.mortgageForm.loanparts.length < 3) {
      this.mortgageForm.loanparts.push(0);
    }
  }

  @action removeLoanpart() {
    if (this.mortgageForm.loanparts.length > 1) {
      this.mortgageForm.loanparts.pop();
    }
  }

  @computed get showNhgAlertInfo() {
    return this.mortgageForm.nhg;
  }

  @computed get showRiskClassReductionSwitch() {
    return this.selectedLabelHasAutoRiskClassReduction();
  }
}

const CalculationFormData = new CalculationFormStore(initialMortgageForm);

export default CalculationFormData;
